export default "__VITE_ASSET__89cc4357__"